<template>
    <div>
        <el-tree
            v-if="popover === false"
            highlight-current
            node-key="id"
            :current-node-key="selectNodeId"
            :default-expanded-keys="[1]"
            :expand-on-click-node="false"
            :data="treeData"
            :props="defaultProps"
            @node-click="handleTreeNode"
            :class="defaultClass"
        />

        <el-popover
            v-if="popover === true"
            placement="bottom"
            width="200"
            trigger="focus"
            @after-enter='treeShow'>
            <el-tree
                v-if="!isRead"
                highlight-current
                node-key="id"
                ref="tree"
                :current-node-key="selectNodeId"
                :default-expanded-keys="[1]"
                :expand-on-click-node="false"
                :data="treeData"
                :props="defaultProps"
                @node-click="handleTreeNode"
                :class="defaultClass"
            />
            <el-input :disabled="isRead"  slot="reference" readonly v-model="popoverTreeLable"></el-input>
        </el-popover>
    </div>
</template>

<script>
    import { getSerialNumberTreeList, getCustomerSerialNumberTreeList } from '@/data-model';
    export default {
        name: 'SerialNumber',
        data () {
            return {
                treeData: [],
                selectNodeId: 0,
                popoverTreeLable: ''
            };
        },
        props: {
            rootId: { // 获取节点树结构数据时的根节点id
                type: [ Number, String ]
            },
            data: { // 外部传入的树的结构数据，如果没有传，使用组件自己的接口获取数据
                type: Array
            },
            selectedNode: { // 默认选中的树节点对象
                type: Object
            },
            defaultProps: { // 默认字段名配置
                type: Object
            },
            popover: { // 是否为弹出树
                type: Boolean,
                default: false
            },
            channelFlag: { // 外部传入的渠道标识，默认是客户使用，US客户，CS客服
                type: String,
                default: 'US'
            },
            appId: { // 外部传入的渠道标识，所属应用（客服系统过来用）
                type: String
            },
            isRead: {
                type: Boolean,
                default: false
            },
            defaultClass: {
                type: String,
                default: 'serialnumber-tree'
            },
            callBackData: {
                type: Object
            }
        },
        created () {
            this._initPage();
        },
        methods: {
            async _initPage () {
                await this._getTreeData();
                this._setSelectedNode();
            },
            async _getTreeData () {
                let serialNumberList = [];
                if (this.data) {
                    serialNumberList = this.data;
                } else {
                    if (this.channelFlag === 'CS') {
                        serialNumberList = await getCustomerSerialNumberTreeList(this.appId);
                    } else {
                        serialNumberList = await getSerialNumberTreeList(this.rootId);
                    }
                }
                this.treeData = serialNumberList;
            },
            _setSelectedNode () {
                if (this.selectedNode) {
                    this.popoverTreeLable = this.selectedNode.label;
                    this.selectNodeId = this.selectedNode.id;
                }
            },
            _refreshSelectedNode (node) {
                if (node) {
                    this.popoverTreeLable = node.title;
                    this.selectNodeId = node.value;
                }
            },
            handleTreeNode (data, node, tree) {
                this.popoverTreeLable = data.label;
                if (this.callBackData) {
                    data.callBackData = this.callBackData;
                }
                this.$emit('nodeClick', data, node, tree);
            },
            setTreeStatus () {
                this.$refs.tree.setCurrentNode(2);
            },
            treeShow () {
                // console.log('treeShow');
                // this.setTreeStatus();
                this.$emit('treeShow');
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/SerialNumber/SerialNumber.vue